module.exports = __webpack_public_path__ + "static/media/filter3.430b2cf5.png";